import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
// import 'photoswipe/style.css';

new PhotoSwipeLightbox({
  gallery: '#gallery--super-dorm',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--six-dorm',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--four-dorm',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--delux-bed',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--semi-bed',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--std-bed',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();